import { render } from "./SaveCustomer.vue?vue&type=template&id=63fc5129"
import script from "./SaveCustomer.vue?vue&type=script&lang=js"
export * from "./SaveCustomer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__